// A robust way of getting a reference to the global object.
// See http://stackoverflow.com/questions/14119988/return-this-0-evalthis/14120023#14120023
// eslint-disable-next-line no-eval
export const globalObject: Window = (0, eval)('this');

/**
 * Returns true of the specified property name path exists from the global object.
 * E.g. <code>isGlobalObject("define")</code> or <code>isGlobalObject("Common", "API", "TVKeyValue")</code>
 * or <code>isGlobalObject("Common.API.TVKeyValue")</code>
 * @returns {boolean}
 */
export const isGlobalObject = (...args: string[]): boolean => {
  let scope = globalObject;
  for (let i = 0; i < args.length; i += 1) {
    const value = args[i];
    const parts = value.split('.');
    for (let j = 0; j < parts.length; j += 1) {
      const part = parts[j];
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const newScope = scope[part];
      if (newScope === null || newScope === undefined) {
        return false;
      }
      scope = newScope;
    }
  }
  return true;
};

/**
 * @param obj
 * @param filter = "simpleOnly" means only strings, numbers, boolean;
 *  "showFunctions" means also show functions
 * @return {*}
 */
/* eslint-disable no-continue */
export const dumpObject = (obj: unknown, filter?: string | boolean): unknown => {
  let filterString = filter;
  if (filterString === true) filterString = 'simpleOnly'; // for backwards compatability
  if (isSimple(obj)) return obj;
  const dump: Record<string, unknown> = {};
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  for (let i = 0; i < Object.keys(obj); i += 1) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const prop = Object.keys(obj)[i];
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    let value = obj[prop];
    if (isSimple(value)) {
      // use as is
    } else if (typeof value === 'function') {
      if (filterString !== 'showFunctions') continue;
      value = 'function()';
    } else if (filterString === 'simpleOnly' && !isSimple(value)) {
      continue;
    } else if (value && typeof value === 'object') {
      value = value.toString();
    }

    dump[prop] = value;
  }
  return dump;
};
/* eslint-enable no-continue */

const isSimple = (value: unknown): boolean =>
  value === null ||
  value === undefined ||
  (typeof value !== 'object' && typeof value !== 'function');

export const isString = (value: unknown): value is string => typeof value === 'string';

export const isArray = (value: unknown): value is unknown[] =>
  value instanceof Array ||
  Object.prototype.toString.call(value) === '[object Array]';

export const isArguments = (value: unknown): boolean =>
  Object.prototype.toString.call(value) === '[object Arguments]';
